import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ReevalJobTarget, reevalTargetKey } from '@shared/models/reeval-job.model';
import { ReevalJobService } from '@shared/services/reeval-job.service';

/**
 * Background re-evaluation status of one element: a spinner while a job runs, then a refresh
 * icon when the job finished with changes that have not been loaded yet.
 */
@Component({
  selector: 'reeval-status-icon',
  templateUrl: './reeval-status-icon.component.html',
  styleUrls: ['./reeval-status-icon.component.scss'],
  standalone: false
})
export class ReevalStatusIconComponent implements OnChanges {
  @Input() target: ReevalJobTarget;
  /** False shows only the spinner (e.g. the claim tool, which has nothing to reload). */
  @Input() allowRefresh = true;
  @Output() refresh = new EventEmitter<void>();

  pending$: Observable<boolean> = of(false);
  ready$: Observable<boolean> = of(false);
  private key: string;

  constructor(private reevalJobService: ReevalJobService) {}

  ngOnChanges(): void {
    // Hosts pass a getter that builds a new object on every check; only resubscribe when the element changes.
    const key = this.target?.docId != null && this.target?.elementId != null ? reevalTargetKey(this.target) : null;
    if (key === this.key) {
      return;
    }
    this.key = key;
    this.pending$ = key ? this.reevalJobService.pending$(this.target) : of(false);
    this.ready$ = key ? this.reevalJobService.ready$(this.target) : of(false);
  }

  onRefreshClick(event: MouseEvent): void {
    event.stopPropagation();
    this.refresh.emit();
  }
}
